import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { SettingsLabel } from "./Utils";
import ImageSelectors from "../../../Component/DigitalMarketing/ImageSelectors";
import { useGetHospitalProfileDetailsQuery } from "../../../Service/settings";
import Store from "../../../store/Store";
function HospitalProfile() {
  const [selectedImage, setSelectedImage] = useState(null);
  const response :any = useGetHospitalProfileDetailsQuery(Store.getState().auth.hospital_code);

  return (
    <>
      <Row className="mt-4 mx-3">
        <Col md={10} className="mb-3">
          <div className="d-flex">
            <ImageSelectors
              setSelectedImage={setSelectedImage}
              existingImage={selectedImage || response?.data?.hospitalImage}
              classes="setting-img"
              disab={true}
            />
            <div className="w-100 mx-3 d-flex align-items-center">
              <h3 className="f-28 blue-c">{response?.data?.branchName}</h3>
            </div>
          </div>
        </Col>
        {SettingsLabel?.map((item, index) => {
          return (
            <Col className="mb-2" md={item?.width ? item.width : 6}>
              <item.tag key={index} {...response?.data} {...item} disab={true} />
            </Col>
          );
        })}
      </Row>
    </>
  );
}

export default HospitalProfile;
